import React from "react";
import { Form } from "react-bootstrap";
import { useLingui } from "@lingui/react/macro";

import type { IPlantData } from "@/lib/backend/manufacturing2.generated.types";
import type { ModelsStagingFilterState } from "./modelsStaging.lib";

type Props = {
    plants: IPlantData[];
    filters: ModelsStagingFilterState;
    disabled?: boolean;
    onFiltersChange: (filters: ModelsStagingFilterState) => void;
};

const ModelsStagingFilterFields = ({ plants, filters, disabled = false, onFiltersChange }: Props) => {
    const { t } = useLingui();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = event.target;
        onFiltersChange({
            ...filters,
            [name]: value,
        });
    };

    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label className="mb-1">{t`Plant`}</Form.Label>
                <select
                    name="plant_uuid"
                    className="form-control select_filter_control"
                    value={filters.plant_uuid}
                    disabled={disabled}
                    onChange={handleChange}
                >
                    <option value="">{t`All plants`}</option>
                    {plants.map(plant => (
                        <option key={plant.uuid} value={plant.uuid}>
                            {plant.title}
                        </option>
                    ))}
                </select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className="mb-1">{t`Material`}</Form.Label>
                <Form.Control
                    type="text"
                    name="material_external_id"
                    placeholder={t`Material external ID`}
                    value={filters.material_external_id}
                    disabled={disabled}
                    onChange={handleChange}
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className="mb-1">{t`Line`}</Form.Label>
                <Form.Control
                    type="text"
                    name="line_external_id"
                    placeholder={t`Line external ID`}
                    value={filters.line_external_id}
                    disabled={disabled}
                    onChange={handleChange}
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className="mb-1">{t`Process`}</Form.Label>
                <Form.Control
                    type="text"
                    name="process_num"
                    placeholder={t`Process number`}
                    value={filters.process_num}
                    disabled={disabled}
                    onChange={handleChange}
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className="mb-1">{t`Min. diff %`}</Form.Label>
                <Form.Control
                    type="text"
                    name="min_diff_pct"
                    placeholder={t`e.g. 5`}
                    value={filters.min_diff_pct}
                    disabled={disabled}
                    onChange={handleChange}
                />
            </Form.Group>

            <Form.Group className="mb-0">
                <label className="mb-0 d-flex align-items-center gap-1">
                    <input
                        type="checkbox"
                        checked={filters.pending_only}
                        disabled={disabled}
                        onChange={event =>
                            onFiltersChange({
                                ...filters,
                                pending_only: event.target.checked,
                            })
                        }
                    />
                    {t`Pending version only`}
                </label>
            </Form.Group>
        </>
    );
};

export default ModelsStagingFilterFields;
